import { Component, Inject, Input, OnInit } from '@angular/core';
import { TaskManagerService } from 'app/modules/remote-control/services/task-manager.service';
import { TaskManagerState } from 'app/modules/remote-control/services/taskManagerState';
import { hd } from '@nx-fe/services';
import { RcContext } from 'app/modules/remote-control-ng/context/rcContext';

@Component({
  selector: 'app-task-details-windows',
  templateUrl: './task-details-windows.component.html',
  styleUrls: ['./task-details-windows.component.scss'],
})
export class TaskDetailsWindowsComponent implements OnInit {
  @Input()
  public deviceKind: string;
  public threadList: hd.IWindowsProcessThread[] = [];
  public moduleList: hd.IWindowsProcessModule[] = [];
  public state: TaskManagerState;
  public threadTableSortInfo: hd.ISortInfo;
  public moduleTableSortInfo: hd.ISortInfo;

  constructor(
    private taskManagerService: TaskManagerService) { }
  ngOnInit() {
    this.state = this.taskManagerService.getState(RcContext.instance.sotiAssistDeviceId) as any;
    this.threadTableSortInfo = this.state.sortInfos[hd.TaskManagerTables.windowsThreadTable];
    this.moduleTableSortInfo = this.state.sortInfos[hd.TaskManagerTables.windowsModuleTable];
  }

  public sortThreadTableBy = (column: string) => {
    this.state.sortTableBy(column, this.state.windowsTaskThreads, this.threadTableSortInfo);
  };

  public sortModuleTableBy = (column: string) => {
    this.state.sortTableBy(column, this.state.windowsTaskModules, this.moduleTableSortInfo);
  };

  public goBack = () => {
    this.state.inDetailsView = false;
  };
}
